import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { requestDeletingWeakness } from "../redux/actions/weaknessesActionCreators";
import {
  requestDeletingAsset,
  requestDeletingUserAsset,
} from "../redux/actions/assetsActionCreators";
import {
  requestDeletingRisk,
  requestDeleteRiskAsset,
  requestDeleteRiskWeakness,
} from "../redux/actions/risksActionCreators";
import { useDispatch } from "react-redux";
import { translate } from "../utils/utils";

const DeleteForm = ({
  open,
  handleClose,
  id,
  rowDetails,
  type,
  riskAsset,
  riskWeakness,
  risk,
  orgaAssetAssinged,
  accountId,
  userRole,
  page,
  searchText,
  filter,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser).account_type;
  const organizationId = JSON.parse(storedUser).organization_id;

  const handleDelete = () => {
    if (type === "asset" && riskAsset) {
      dispatch(
        requestDeleteRiskAsset(rowDetails?.id, risk, accountType, accountId)
      );
    } else if (type === "weakness" && riskWeakness) {
      dispatch(
        requestDeleteRiskWeakness(rowDetails?.id, risk, accountType, accountId)
      );
    } else if (type === "asset") {
      if (orgaAssetAssinged && (userRole === "enterprise_admin" || userRole === "cytailor_admin")) {
        dispatch(
          requestDeletingUserAsset(
            page,
            searchText,
            filter,
            id,
            organizationId,
            accountType
          )
        );
      } else {
        dispatch(
          requestDeletingAsset(
            page,
            searchText,
            filter,
            id,
            accountType,
            accountId
          )
        );
      }
    } else if (type === "weakness") {
      dispatch(
        requestDeletingWeakness(
          page,
          searchText,
          filter,
          id,
          accountType,
          accountId
        )
      );
    } else {
      dispatch(
        requestDeletingRisk(
          page,
          searchText,
          filter,
          id,
          accountType,
          accountId
        )
      );
    }
    handleClose();
  };

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={open}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
        PaperProps={{ sx: { padding: "40px 10px ", width: "100%" } }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 2 }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle id="draggable-dialog-title" sx={{ margin: "0px 20px" }}>
          <Typography
            variant="title4"
            sx={{
              fontSize: "25px",
            }}
          >
            {rowDetails[translate("title")] || t("not_specified")}
          </Typography>
        </DialogTitle>{" "}
        <DialogContent sx={{ margin: "10px 20px" }}>
          <DialogContentText>
            {rowDetails[translate("description")] || t("not_specified")}
          </DialogContentText>
        </DialogContent>
        <DialogActions align="center">
          <Grid container>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="deleteButton"
                sx={{ width: "90%" }}
                onClick={handleDelete}
              >
                {riskAsset || riskWeakness
                  ? `${t("remove")} ${t(type)}`
                  : `${t("delete")} ${t(type)}`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteForm;
